// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__p1hz3","createdSearch":"index_createdSearch__TSj9m","custom_table":"index_custom_table__SJj4T"};